export default __webpack_public_path__ + "static/media/rectangle4.22531038.png";